import React from "react";
import {connect} from "react-redux";
import {Text,StyleSheet} from "react-native";
import moment from "moment";
import {withTranslation} from "react-i18next";
import {compose} from "redux";

class PostDate extends React.Component{
    constructor(props) {
        super(props);

        // if publish_date has been specified use it
        const date = this.props.post.publish_date || this.props.post.inserted_at
        const fd = this._getDateFormat(date);
        this.date_str = fd.unit ? this.props.t("date_ago", { date: fd.value + fd.unit.label }) : fd.formatted;
    }

    // Exammple format: "2021-06-25T09:28:00"
    _getDateFormat(date){

        let m  = moment.utc(date);
        let today = moment.utc();
        let d = today.unix() - m.unix() ;
        let ago = {label : 'h', v : "hours"};

        if(d<60){
            ago = {label : 's', v : "seconds"};
        }else if (d<3600){
            ago = {label : 'min', v : "minutes"};
        }else if (d<86400){
            ago = {label : 'h', v : "hours"};
        }else if(d<604800){
            ago = {label : this.props.t('d'), v : "days"};
        }else{
            ago = false;
        }

        let diff, formatted;
        if (ago !== false) {
            diff = today.diff(m,ago.v);
            formatted = diff + " " + ago.label;
        } else {
            formatted = diff = m.local().format("DD/MM/Y");
        }

        return {value: diff, unit: ago, formatted};
    }

    render() {

       const styles = StyleSheet.create({
            datePost:{
                fontFamily: this.props.theme.fonts.text,
                fontWeight:"500",
                fontSize:13,
                color : this.props.theme.colors.tertiary.black6.value,
            }
        });
        return <Text style={styles.datePost}>{ this.date_str }</Text>;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(PostDate);
